import React, { useState } from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CreateGroupForm } from "../components/groups";
import { groupAPI } from "../services/api";

const GroupCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCreate = async (payload: {
    name: string;
    type: "family" | "business" | "custom";
    description?: string;
  }) => {
    try {
      setLoading(true);
      const group = await groupAPI.create(payload);
      navigate(`/groups/${group.id}`);
    } catch (error) {
      console.error("Failed to create group:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <CreateGroupForm onSubmit={handleCreate} loading={loading} />
    </Container>
  );
};

export default GroupCreatePage;
